import React, { useEffect, useState } from 'react';

const Message = () => {
    const [message, setMessage] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const response = await fetch('https://saha-reno-portfolio-backend.onrender.com/message');
                const data = await response.json();
                setMessage(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching messages:', error);
                setLoading(false);
            }
        };

        fetchMessages();
    }, []);

    return (
        <div>
            <div className=''>
                {loading && <div className='MainLoader text-center py-52'><span className="loader"></span></div>}
                {!loading && message?.map((m) => (
                    <div className='m-6 shadow-2xl p-5 shadow-slate-400 border-2 rounded-2xl' key={m._id}>
                        <p className='font-bold'>From: <span className='text-red-600'>{m.name}</span></p>
                        <p><b>Email:</b> <span className='text-xs font-bold text-blue-600'><a href={`mailto:${m.email}`}><u>{m.email}</u></a></span></p>
                        <p><b>Message:</b> {m.message}</p>
                        <p><b>Time:</b> {m.time}</p>
                        <p><b>Date:</b> {m.date}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Message;